// setting the Authorization header for the outgoing requests
import { setContext } from 'apollo-link-context';
import { AsyncStorage } from 'services';
import { appVersion, appEnvironment } from 'helpers/constants';

export const authLink = setContext(
  (request) =>
    new Promise((success, fail) => {
      AsyncStorage.get('accessToken')
        .then((token) => {
          success({
            headers: {
              'fyi-authorization': token ? `Bearer ${token}` : '',
              'fyi-app-version': appVersion,
              'fyi-app-platform': appEnvironment,
            },
          });
        })
        .catch((error) => {
          // TO-DO: Track as warning
          success({
            headers: {
              'fyi-app-version': appVersion,
              'fyi-app-platform': appEnvironment,
            },
          });
        });
    })
);
